import { render, staticRenderFns } from "./cmp-actionsBankTransfer.vue?vue&type=template&id=b86a4c42&"
import script from "./cmp-actionsBankTransfer.vue?vue&type=script&lang=js&"
export * from "./cmp-actionsBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports